export { default } from "./GraficaDiaria";
